import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui';
import type { IAdminMessagePreviewModalProps } from '@/interfaces';
import { MessageLanguageEnum } from '@/enums';

const PreviewModal = ({ open, activeLang, previewText, previewCta, onChangeLang, onClose }: IAdminMessagePreviewModalProps) => {
  const linkText = previewCta?.text[activeLang.toLowerCase() as 'fr' | 'en'];

  const renderPreviewText = () => {
    if (!previewCta || !linkText || !previewText.includes(linkText)) {
      return <span>{previewText.trim().length ? previewText : 'Ton message apparaîtra ici…'}</span>;
    }

    const parts = previewText.split(linkText);
    return (
      <>
        {parts.map((part, i) => (
          <span key={i}>
            {part}
            {i < parts.length - 1 && (
              <span className='text-primary underline cursor-pointer'>{linkText}</span>
            )}
          </span>
        ))}
      </>
    );
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="w-[calc(100%-2rem)] sm:max-w-[420px] rounded-2xl duration-0 animate-none">
        <DialogHeader>
          <DialogTitle>Preview</DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          <div className="flex items-center gap-1 text-xs">
            <button
              type="button"
              className={`px-2 py-1 rounded-md ${activeLang === MessageLanguageEnum.FR ? 'bg-foreground text-background' : 'border border-border hover:border-foreground'}`}
              onClick={() => onChangeLang(MessageLanguageEnum.FR)}
            >
              FR
            </button>
            <button
              type="button"
              className={`px-2 py-1 rounded-md ${activeLang === MessageLanguageEnum.EN ? 'bg-foreground text-background' : 'border border-border hover:border-foreground'}`}
              onClick={() => onChangeLang(MessageLanguageEnum.EN)}
            >
              EN
            </button>
          </div>
          <div className="rounded-xl border border-border p-4 bg-purple-500/5">
            <div className="text-xs text-muted-foreground">System • maintenant</div>
            <div className="mt-2 text-sm leading-relaxed">{renderPreviewText()}</div>
          </div>
          <div className="text-xs text-muted-foreground">
            Le message est envoyé par l'utilisateur système et visible dans la conversation.
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewModal;
